import React from 'react';
import { Reveal } from './Reveal';
import { GlassWhatsApp } from './ContactButtons';
export function Testimonials() {
  return <section className="relative w-full bg-ink py-16 sm:py-24" data-id="element-171" data-mp="3krp5n656qzqv">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" data-id="element-172" data-mp="3fz5nrwzgtig9" />
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-173" data-mp="3azjcht376ca3">
        <Reveal data-id="element-174" data-mp="36yzeyoepp6nf">
          <h2 className="font-serif text-4xl leading-tight text-gold-light sm:text-5xl" data-id="element-175" data-mp="36zilza2tqamo">
            ¡Lo que dicen de nosotros!
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-176" data-mp="321z9ofpos7xd">
          <p className="mx-auto mt-5 max-w-xl font-sans text-base leading-relaxed text-white/65" data-id="element-177" data-mp="2x0jmoi3y7rcc">
            Historias reales de personas que confiaron su proceso amoroso a nuestros maestros.
          </p>
        </Reveal>

        <Reveal delay={0.18} data-id="element-178" data-mp="v9oqhp5txq53">
          <div className="mt-12 overflow-hidden rounded-[1.75rem] border border-white/10 bg-black shadow-[0_50px_120px_-50px_rgba(0,0,0,0.95)]" data-id="element-179" data-mp="v8wvafg59ufc">
            <div className="relative aspect-video w-full" data-id="element-180" data-mp="h67xw01xbg89">
              <iframe src="https://www.youtube.com/embed/videoseries?list=PLbpi6ZahtOH6Blw3RGYpWkSByi_T7Rygb" title="Testimonios reales de nuestros consultantes" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen className="absolute inset-0 h-full w-full border-0" data-id="element-181" data-mp="h4n44cnfo1bg" />
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.26} data-id="element-182" data-mp="14xdeihfoucjm">
          <div className="mt-10 flex justify-center" data-id="element-183" data-mp="q766kvnb4bx6">
            <GlassWhatsApp data-id="element-184" data-mp="q4jy8tsldsdw">Escribir vía WhatsApp</GlassWhatsApp>
          </div>
        </Reveal>
      </div>
    </section>;
}